import { AlertBasic } from "@wojo/ui";
import cn from "clsx";
import { LineItemStatus, TripStatus } from "generated/graphql";
import styles from "../base-table/BaseTable.module.scss";

export type StatusCellProps = {
    status: TripStatus | LineItemStatus;
};

const mapStatuses = (status: TripStatus | LineItemStatus) => {
    switch (status) {
        case TripStatus.Confirmed:
        case LineItemStatus.Confirmed:
            return (
                <AlertBasic
                    status="confirmed"
                    iconAltText=""
                    title={status.toLowerCase()}
                />
            );
        case TripStatus.Requested:
        case LineItemStatus.Requested:
            return <AlertBasic status="info" iconAltText="" title="Pending" />;
        case TripStatus.Cancelled:
        case LineItemStatus.Cancelled:
            return (
                <AlertBasic
                    status="alert"
                    iconAltText=""
                    title={status.toLowerCase()}
                />
            );
        default:
            return status.toLowerCase();
    }
};

export const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
    return (
        <span
            className={cn(styles.status, {
                [styles["status--confirmed"]]:
                    status === TripStatus.Confirmed ||
                    status === LineItemStatus.Confirmed,
            })}
        >
            {mapStatuses(status)}
        </span>
    );
};
